var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#96989C",
    d: "M6 14 20 4l14 10v19a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.817 27.443-5.783-5.817c.572-1.47.255-3.197-.953-4.411-1.144-1.151-2.803-1.473-4.236-1.013-.231.074-.284.364-.113.537l2.134 2.147a.35.35 0 0 1 0 .493l-1.415 1.424a.35.35 0 0 1-.494.003l-2.204-2.166c-.17-.167-.452-.119-.53.106-.508 1.446-.138 3.128 1.012 4.286 1.208 1.215 2.923 1.534 4.385.959l5.782 5.817a.612.612 0 0 0 .89 0l1.461-1.47c.318-.256.318-.703.064-.895Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3E42",
    d: "M36.835 17.138a2.159 2.159 0 0 1-3.074.515L20 7.389 6.24 17.653a2.159 2.159 0 0 1-2.582-3.46L20 2l16.342 12.192a2.159 2.159 0 0 1 .493 2.946Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair);
export default __webpack_public_path__ + "static/media/Repair.eba2a55dd7f2506d3d49b67d70b71200.svg";
export { ForwardRef as ReactComponent };